import { loadStripe } from '@stripe/stripe-js';

export default (key: string) => loadStripe(key);
